import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
`;

export const Error = styled.span`
  padding-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.input.errorColor};
`;

export const SelectType = styled.select`
  height: 48px;
  width: 100%;
  background: ${ColorPalette.Transparent};
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  text-indent: 10px;
  border-radius: 8px;
  color: ${({ theme }) => theme.input.color};
  border: ${({ theme }) => `1px solid ${theme.input.border}`};
`;

export const Box = styled.div`
  flex-grow: 3;
`;
